import { createSelector } from 'reselect'
import { StoreState } from '../../store/store'

const routerSelector = (state: StoreState) => state.router

export const locationState = createSelector([routerSelector], (router) => router.location.state || {})
export const pathname = createSelector([routerSelector], (router) => router.location.pathname)
export const urlHash = createSelector([routerSelector], (router) => router.location.hash)
export const query = createSelector([routerSelector], (router) => router.location.query)
